import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "data",
  initialState: {
    datas: [],
    ID: null,
    url: [],
    isLoading: false
  },
  reducers: {
    getData: (action, state) => {
      state.isLoading = true;
      action = state.payload.url;
    },
    getDataSuccess: (state, action) => {
      state.datas =  action.payload ;
      state.isLoading = false;

    },
    setDataID: (state, action) => {

    }
  }
});
export const { getData, getDataSuccess, setDataID } = dataSlice.actions;
export default dataSlice;
